import { useGlossariesOptions } from 'providers/GlossaryProviders/useGlossariesOptions';
import { Option } from 'types/Option';

interface IUseOptionsGlossaries {
  optionsGlossaries: Option[];
}

export default function useOptionsGlossaries(): IUseOptionsGlossaries {
  const { data } = useGlossariesOptions();

  const optionsGlossaries = [
    ...(data?.map(({ id, name }) => ({
      label: name,
      value: String(id)
    })) ?? [])
  ];

  return { optionsGlossaries };
}
